import BaseEntity from '../base/BaseEntity.model';

export default class AcademicArea extends BaseEntity{
    public name?: string | null;

    constructor(){
        super();
        this.init();
    }

    init(){
        this.name = null;
    }
}